import React, { useCallback, useEffect, useRef, useState } from "react";
import SideNavPOS from "../components/POS/SideNavPOS";
import POSOrderDetailTable from "../components/POS/POSOrderDetailTable";
import POSRightHeader from "../components/POS/POSRightHeader";
import POSCategory from "../components/POS/POSCategory";
import axios from "axios";
import { apiKey } from "../config/config";
import handleCSRF from "../config/CSRF";
import POSOrderDetail from "../components/POS/POSOrderDetail";
import InvoiceMain from "../components/Invoices/InvoiceMain";
import { useReactToPrint } from "react-to-print";
import { useNavigate } from "react-router-dom";
import { RxCross1 } from "react-icons/rx";
import KOTSingle from "../components/Invoices/KOTSingle";
import { IoMdMenu } from "react-icons/io";

function POSMain() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [menuOpen, setMenuOpen] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [pageLoading, setPageLoading] = useState(true);
  const [showOrderDetailModal, setShowOrderDetailModal] = useState(false);
  const [orders, setOrders] = useState([]);
  const [deliveryOrders, setDeliveryOrders] = useState([]);
  const [dineInOrders, setDineInOrders] = useState([]);
  const [takeawayOrders, setTakeawayOrders] = useState([]);
  const [holdOrders, setHoldORders] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [foodMenus, setFoodMenus] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [waiters, setWaiters] = useState([]);
  const [riders, setRiders] = useState([]);
  const [cashiers, setCashiers] = useState([]);
  const [tables, setTables] = useState([]);
  const [isSubCat, setIsSubCat] = useState(false);
  const [selectOrder, setSelectOrder] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [selectedOrderType, setSelectedOrderType] = useState(null);
  const [orderDetails, setOrderDetails] = useState(null);
  const [orderItemDetail, setOrderItemDetail] = useState([]);
  const [totalItems, setTotalItems] = useState(null);
  const [totalVat, setTotalVat] = useState(null);
  const [subTotal, setSubTotal] = useState(null);
  const [totalDiscount, setTotalDiscount] = useState(null);
  const [discount, setDiscount] = useState(0);
  const [discountVal, setDiscountVal] = useState(0);
  const [serviceDelivery, setServiceDelivery] = useState(null);
  const [allPaymentMethod, setAllPaymentMethod] = useState(null);
  const [totalPayable, setTotalPayable] = useState(0);
  const [mainScreenDiscountType, setMainScreenDiscountType] = useState(null);
  const [mainScreenDiscount, setMainScreenDiscount] = useState(0);
  const [additionalDiscount, setAdditionalDiscount] = useState(0);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(1);
  const [multiplePayments, setMultiplePayments] = useState([]);
  const [selectedCustomerId, setSelectedCustomerId] = useState(1);
  const [selectedCustomer, setSelectedCustomer] = useState(false);
  const [setting, setSetting] = useState([]);
  const [invoiceData, setInvoiceData] = useState(null);
  const [isUpdate, setIsUpdate] = useState(false);
  const [loyalty, setLoyalty] = useState(null);
  const [loyaltyPoints, setLoyaltyPoints] = useState("");
  const [cardDiscountType, setCardDiscountType] = useState("amount");
  const [cardDiscountAmount, setCardDiscountAmount] = useState(0);
  const [alert, setAlert] = useState(null);
  const [selectedCashier, setSelectedCashier] = useState("");
  const [selectedWaiter, setSelectedWaiter] = useState("");
  const [selectedTable, setSelectedTable] = useState(null);
  const [showFinalizeOrderModal, setShowFinalizeOrderModal] = useState(false);
  const [showDirectInvoiceFinalizeModal, setShowDirectInvoiceFinalizeModal] =
    useState(false);
  // const [paidAmount, setPaidAmount] = useState(0);
  const [payAmount, setPayAmount] = useState(0);
  const [dueAmount, setDueAmount] = useState(0);
  const [givenAmount, setGivenAmount] = useState(0);
  const [changeAmount, setChangeAmount] = useState(0);
  const [totalPayableFinal, setTotalPayableFinal] = useState(0);
  const [openKotModal, setOpenKotModal] = useState(false);

  const handleCardDiscountType = (value) => {
    setCardDiscountType(value);
  };

  const handleCardDiscountAmount = (value) => {
    setCardDiscountAmount(value);
  };

  const navigate = useNavigate();

  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "Invoice",
  });

  const handleCloseAlert = () => {
    setAlert(null);
  };

  const handleLoyalty = (points) => {
    setLoyaltyPoints(points);
  };
  const handleItemSelect = (item) => {
    setOrderItemDetail((prev) => {
      // Check if the item already exists in the order
      // const existingItemIndex = prev.findIndex(
      //   (orderItem) => orderItem.food_menu_id === item.id
      // );

      // // If the item exists, increment the quantity
      // if (existingItemIndex !== -1) {
      //   return [...prev];
      // }

      // If the item doesn't exist, add a new item
      return [
        ...prev,
        {
          food_menu_name: item.name,
          food_menu_id: item.id,
          food_menu_cooking_end_time: "",
          food_menu_cooking_start_time: "",
          food_menu_cooking_status: "",
          is_deal: item.is_deal,
          is_out_of_stock: item.out_of_stoct,
          deal_details: item.deal_details || null,
          food_menu_note: "",
          food_menu_qty: 1,
          food_menu_unit_price: item.sale_price,
          food_menu_original_unit_price: item.sale_price,
          food_menu_modifiers: item.modifiers,
          food_menu_vat: item.sale_price_vat_price,
          food_menu_extra_vat: item.sale_price_extra_vat_price,
          food_menu_discount:
            item.discount.length > 0
              ? item.discount[0]?.dis_type === "amount"
                ? item.discount[0]?.discount_amount
                : item.sale_price * (item.discount[0]?.discount_amount / 100)
              : 0,
          food_menu_total_sale_price:
            item.tax_method === "inclusive"
              ? item.sale_price - item.sale_price_vat_price
              : item.sale_price,
          food_menu_original_discount:
            item.discount.length > 0
              ? item.discount[0]?.dis_type === "amount"
                ? item.discount[0]?.discount_amount
                : item.sale_price * (item.discount[0]?.discount_amount / 100)
              : 0,
          food_menu_after_discount: item.sale_price_discount_price,
          food_menu_modifier_selected: [],
        },
      ];
    });
  };

  const handleCreateInvoice = () => {
    if (!selectOrder) {
      setAlert("Please select an order to proceed!");
      return;
    }
    const order = {
      customer_id: parseInt(selectOrder.customer_id),
      redeem_point: selectOrder.loyalty_point_amount || 0,
      is_guest: selectOrder.is_guest,
      name:
        selectOrder.is_guest === "yes" ? selectOrder.guest?.name : undefined,
      session_id: "request",
      is_request: "pos",
      // is_coupon: "yes",
      // coupon_id: 1,
      user_id: user.user.id,
      waiter_id: selectOrder.waiter_id,
      cashier_id: selectOrder.cashier_id,
      order_from: selectOrder.order_from,
      order_type_id: selectOrder.order_type_id,
      is_coupon: selectOrder.is_coupon,
      coupon_code: selectOrder.coupon_code,
      payment_method_id: selectOrder.payment_method_id,
      card_discount_type: selectOrder.card_discount_type,
      card_discount: selectOrder.card_discount,
      multiple_payments: selectOrder.multiple_payments,
      table_id: selectedTable,
      outlet_id: selectOrder.outlet_id,
      sub_total: selectOrder.sub_total,
      paid_amount: payAmount,
      received_amount: givenAmount || 0,
      change_amount: changeAmount,
      main_screen_discount_type: selectOrder.main_screen_discount_type,
      main_screen_discount: selectOrder.main_screen_discount,
      order_status: "invoiced",
      approval_status: "approved",
      delivery_charges: selectOrder.delivery_charges,
      items: selectOrder.order_details.map((order) => ({
        item_id: order.food_menu_id,
        quantity: order.qty,
        menu_note: order.menu_note,
        modifiers: order.modifiers?.map((modifier) => {
          // console.log(modifier);
          return {
            modifier_id: modifier.modifier_id || modifier.id,
            quantity: 1,
          };
        }),
      })),
    };
    const addSale = async () => {
      try {
        const res = await axios.put(
          `${apiKey}/api/rms/admin/update_sale/${selectOrder.id}`,
          order,
          {
            headers: {
              Authorization: `Bearer ${user?.token}`,
            },
          }
        );
        setInvoiceData(res.data.order_details.original);
        setTimeout(() => {
          handlePrint();
          setSelectOrder(null);
          setSelectedOrder(null);
          setOrderItemDetail([]);
          setSelectedCustomerId(1);
          setSelectedOrderType(null);
          setMainScreenDiscount(0);
          setMainScreenDiscountType(null);
          setServiceDelivery(0);
          setSelectedPaymentMethod(1);
          setSelectedCashier("");
          setSelectedWaiter("");
          setSelectedTable("");
          setServiceDelivery(0);
          setShowOrderDetailModal(false);
          setShowFinalizeOrderModal(false);
          setPayAmount(0);
          setDueAmount(0);
          setTotalPayableFinal(0);
          setGivenAmount(0);
          setChangeAmount(0);
        }, 100);
        fetchOrders();
      } catch (err) {
        console.log(err);
      }
    };

    addSale();
  };

  const handleItemDelete = (index) => {
    setOrderItemDetail((prev) => {
      return prev.filter((_, i) => i !== index);
    });
  };

  const handleOrderDetailModal = (open) => {
    if (!orderDetails) {
      return;
    }
    setShowOrderDetailModal(open);
  };

  const handleOrderDetails = (order) => {
    setOrderDetails(order);
  };

  const handleSelectOrder = (order) => {
    setSelectOrder(order);
  };

  const handleSelectOrderType = (orderType) => {
    setSelectedOrderType(orderType);
  };

  const handleSelectedPaymentMethod = (paymentMethod) => {
    setSelectedPaymentMethod(paymentMethod);
  };

  const handleIsSubCat = (val) => {
    setIsSubCat(val);
  };

  const handleDiscountUpdate = (amount) => {
    setAdditionalDiscount((prevTotalDiscount) => {
      let discountAmount = 0;
      let prevDiscountAmount = 0;

      // Calculate the previous discount value based on the previous discount type (percentage or fixed)
      if (typeof discount === "string" && discount.includes("%")) {
        const prevPercentage = parseFloat(discount.replace("%", ""));
        if (!isNaN(prevPercentage)) {
          prevDiscountAmount = (prevPercentage / 100) * subTotal;
        }
      } else {
        const prevParsedAmount = parseFloat(discount);
        if (!isNaN(prevParsedAmount)) {
          prevDiscountAmount = prevParsedAmount;
        }
      }

      // Calculate the new discount value based on the current amount
      if (typeof amount === "string" && amount.includes("%")) {
        const percentage = parseFloat(amount.replace("%", ""));
        setMainScreenDiscountType("percentage");

        // If the percentage is greater than 100, reset the discount
        if (isNaN(percentage) || percentage > 100) {
          setMainScreenDiscount(0);
          setDiscountVal(0);
          setDiscount("0%");
          return prevTotalDiscount - prevDiscountAmount;
        }

        if (!isNaN(percentage)) {
          setMainScreenDiscount(percentage);
          discountAmount = (percentage / 100) * subTotal;
        }
      } else {
        const parsedAmount = parseFloat(amount);
        setMainScreenDiscountType("amount");

        // If the discount amount exceeds the subTotal, reset the discount
        if (isNaN(parsedAmount) || parsedAmount > subTotal) {
          setMainScreenDiscount(0);
          setDiscountVal(0);
          setDiscount("0");
          return prevTotalDiscount - prevDiscountAmount;
        }

        if (!isNaN(parsedAmount)) {
          setMainScreenDiscount(parsedAmount);
          discountAmount = parsedAmount;
        }
      }

      setDiscountVal(discountAmount);

      // Calculate the new total discount by subtracting the previous discount and adding the new one
      return prevTotalDiscount - prevDiscountAmount + discountAmount;
    });

    // Store the new discount (as percentage or fixed)
    setDiscount(amount);
  };

  const handleDeliveryChargeUpdate = (amount) => {
    setServiceDelivery(amount);
  };

  const handleEditOrder = () => {
    setSelectedOrder(selectOrder);
    setSelectedOrderType(selectOrder?.order_type_id);
    setOrderItemDetail(
      selectOrder.order_details.map((item) => ({
        food_menu_name: item.name,
        food_menu_id: item.food_menu_id,
        food_menu_cooking_end_time: item.cooking_end_time,
        food_menu_cooking_start_time: item.cooking_start_time,
        food_menu_cooking_status: item.cooking_status,
        is_deal: item.food_menu.is_deal,
        deal_details: item.food_menu.deal_details || null,
        food_menu_note: item.menu_note,
        food_menu_qty: item.qty,
        food_menu_unit_price: item.menu_unit_price,
        food_menu_original_unit_price: item.menu_unit_price,
        food_menu_modifiers: item.food_menu.modifiers,
        food_menu_vat: item.menu_taxes.vat,
        food_menu_extra_vat: item.menu_taxes.additional_vat,
        food_menu_discount: item.menu_taxes.single_discount,
        food_menu_original_discount: item.menu_taxes.single_discount,
        food_menu_total_sale_price: item.menu_taxes.item_price,
        food_menu_after_discount: item.menu_price_with_discount,
        food_menu_modifier_selected: item.modifiers.map((mod) => ({
          modifier_id: mod.id,
          modifier_name: mod.name,
          modifier_price: mod.price,
          quantity: mod.pivot.qty,
        })),
      }))
    );
    setIsUpdate(true);
  };

  const handleUpdateQuantity = (id, newQty) => {
    setOrderItemDetail(
      (prevItems) =>
        // Use filter to remove items with newQty of 0
        prevItems
          .map((item) => {
            // Update the item if the id matches
            return item.food_menu_id === id
              ? {
                  ...item,
                  food_menu_qty: newQty,
                  food_menu_unit_price:
                    item.food_menu_original_unit_price * newQty,
                  food_menu_discount: item.food_menu_original_discount * newQty,
                }
              : item;
          })
          .filter((item) => item.food_menu_qty !== 0) // Remove items with qty 0
    );
  };

  const handleAddModifier = (id, modifiers, note) => {
    setOrderItemDetail((prevItems) => {
      return prevItems.map((item) => {
        return item.food_menu_id === id
          ? {
              ...item,
              food_menu_modifier_selected: modifiers,
              food_menu_note: note,
            }
          : item;
      });
    });
  };

  const sidebarToggle = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleCustomerSelect = (e) => {
    const selectedOption = e.target.options[e.target.selectedIndex]; // Access the selected <option> element
    setSelectedCustomerId(e.target.value); // Get the value of the selected option
    setSelectedCustomer(JSON.parse(selectedOption.dataset.customer)); // Access the data-customer attribute of the selected option
  };

  const handleMultiplePaymentSubmit = (payments) => {
    setMultiplePayments(payments);
  };

  const handleClearOrder = () => {
    if (orderItemDetail.length > 0) {
      if (
        window.confirm("Cart is not empty, want to clear the cart?") !== true
      ) {
        return;
      }
      setOrderItemDetail([]);
      setSelectedCustomerId(1);
      setSelectedOrder(null);
      setSelectOrder(null);
      setIsUpdate(false);
      setSelectedOrderType(null);
      setMainScreenDiscount(0);
      setMainScreenDiscountType(null);
      setServiceDelivery(0);
      setLoyaltyPoints("");
    }
  };

  const handleHoldOrder = () => {
    if (orderItemDetail.length < 1) {
      setAlert("Cart is empty!");
      return;
    }
    if (!selectedOrderType) {
      setAlert("You must select Dine In or Take Away or Delivery!");
      return;
    }
    if (selectedOrder) {
      axios
        .post(
          `${apiKey}/api/rms/admin/order/${selectedOrder.id}/status`,
          {
            approval_status: "hold",
          },
          {
            headers: {
              Authorization: `Bearer ${user?.token}`,
            },
          }
        )
        .then((res) => {
          setOrderItemDetail([]);
          setSelectedCustomerId(1);
          setSelectedOrderType(null);
          setMainScreenDiscount(0);
          setMainScreenDiscountType(null);
          setIsUpdate(false);
          setServiceDelivery(0);
          setLoyaltyPoints("");
          setSelectedCashier("");
          setSelectedWaiter("");
          fetchOrders();
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      const order = {
        customer_id: parseInt(selectedCustomerId),
        loyalty_point_amount: loyaltyPoints,
        is_guest: "no",
        session_id: "request",
        is_request: "pos",
        // is_coupon: "yes",
        // coupon_id: 1,
        user_id: user.user.id,
        waiter_id: selectedWaiter,
        cashier_id: selectedCashier,
        order_from: selectedOrder.order_from,
        order_type_id: selectedOrderType,
        is_coupon: "no",
        payment_method_id: selectedPaymentMethod,
        card_discount_type: cardDiscountType,
        card_discount: cardDiscountAmount,
        table_id: selectedTable,
        outlet_id: user.user.outlet_id,
        sub_total: subTotal,
        received_amount: givenAmount || 0,
        paid_amount: 0,
        main_screen_discount_type: mainScreenDiscountType,
        main_screen_discount: mainScreenDiscount,
        order_status: "new",
        approval_status: "hold",
        delivery_charges: serviceDelivery,
        items: orderItemDetail.map((order) => ({
          item_id: order.food_menu_id,
          quantity: order.food_menu_qty,
          menu_note: order.food_menu_note,
          modifiers: order.food_menu_modifier_selected?.map((modifier) => ({
            modifier_id: modifier.modifier_id,
            quantity: 1,
          })),
        })),
      };

      const addSale = async () => {
        try {
          // eslint-disable-next-line no-unused-vars
          const res = await axios.post(
            `${apiKey}/api/rms/customer/add_sale`,
            order
          );
          // setOrders((prevOrders) => [res.data.order_details, ...prevOrders]);
          // setAlert(
          //   "Order has been added to Running Orders and went to Kitchen Panel as well. Select any order from Running Orders to modify it or create invoice"
          // );
          setOrderItemDetail([]);
          setSelectedCustomerId(1);
          setSelectedOrderType(null);
          setMainScreenDiscount(0);
          setMainScreenDiscountType(null);
          setIsUpdate(false);
          setServiceDelivery(0);
          setLoyaltyPoints("");
          setSelectedCashier("");
          setSelectedTable("");
          setSelectedWaiter("");
          setGivenAmount(0);
          fetchOrders();
        } catch (err) {
          console.log(err);
        }
      };

      addSale();
    }
  };

  const createUpdateOrder = (type) => {
    if (orderItemDetail.length < 1) {
      setAlert("Cart is empty!");
      return;
    }
    if (!selectedOrderType) {
      setAlert("You must select Dine In or Take Away or Delivery!");
      return;
    }

    const order = {
      customer_id: parseInt(selectedCustomerId),
      loyalty_point_amount: loyaltyPoints,
      is_guest: "no",
      session_id: "request",
      is_request: "pos",
      // is_coupon: "yes",
      // coupon_id: 1,
      user_id: user.user.id,
      waiter_id: selectedWaiter,
      cashier_id: selectedCashier,
      order_from: selectedOrder.order_from || "POS",
      order_type_id: selectedOrderType,
      is_coupon: "no",
      payment_method_id: selectedPaymentMethod,
      card_discount_type: cardDiscountType,
      card_discount: cardDiscountAmount,
      table_id: selectedTable,
      outlet_id: user.user.outlet_id,
      sub_total: subTotal,
      received_amount: givenAmount || 0,
      paid_amount: 0,
      main_screen_discount_type: mainScreenDiscountType,
      main_screen_discount: mainScreenDiscount,
      order_status: "new",
      approval_status: "approved",
      delivery_charges: serviceDelivery,
      items: orderItemDetail.map((order) => ({
        item_id: order.food_menu_id,
        quantity: order.food_menu_qty,
        menu_note: order.food_menu_note,
        modifiers: order.food_menu_modifier_selected?.map((modifier) => ({
          modifier_id: modifier.modifier_id,
          quantity: 1,
        })),
      })),
    };

    const addSale = async () => {
      if (type === "create") {
        try {
          const res = await axios.post(
            `${apiKey}/api/rms/customer/add_sale`,
            order
          );
          console.log(res.data);
          // setOrders((prevOrders) => [res.data.order_details, ...prevOrders]);
          setAlert(
            "Order has been added to Running Orders and went to Kitchen Panel as well. Select any order from Running Orders to modify it or create invoice"
          );
          setOrderItemDetail([]);
          setSelectedCustomerId(1);
          setSelectedOrderType(null);
          setMainScreenDiscount(0);
          setMainScreenDiscountType(null);
          setIsUpdate(false);
          setServiceDelivery(0);
          setLoyaltyPoints("");
          setSelectedCashier("");
          setSelectedWaiter("");
          setSelectedTable("");
          fetchOrders();
          setSelectedOrder(null);
          setSelectOrder(null);
          setDiscount(0);
          setGivenAmount(0);
          setDiscountVal(0);
        } catch (err) {
          console.log(err);
        }
      } else {
        try {
          const res = await axios.put(
            `${apiKey}/api/rms/admin/update_sale/${selectedOrder.id}`,
            order,
            {
              headers: {
                Authorization: `Bearer ${user?.token}`,
              },
            }
          );
          console.log(res);
          // setOrders((prevOrders) => [res.data.order_details, ...prevOrders]);
          setAlert(
            "Order has been added to Running Orders and went to Kitchen Panel as well. Select any order from Running Orders to modify it or create invoice"
          );
          setOrderItemDetail([]);
          setSelectedCustomerId(1);
          setSelectedOrderType(null);
          setMainScreenDiscount(0);
          setMainScreenDiscountType(null);
          setIsUpdate(false);
          setServiceDelivery(0);
          fetchOrders();
          setDiscount(0);
          setDiscountVal(0);
          setSelectedOrder(null);
          setGivenAmount(0);
          setSelectOrder(null);
        } catch (err) {
          console.log(err);
        }
      }
    };

    addSale();
  };

  const handleDirectInvoice = () => {
    if (orderItemDetail.length < 1) {
      setAlert("Cart is empty!");
      return;
    }
    if (!selectedOrderType) {
      setAlert("You must select Dine In or Take Away or Delivery!");
      return;
    }
    if (selectedPaymentMethod === 1) {
      setShowDirectInvoiceFinalizeModal(true);
      return;
    }

    const order = {
      customer_id: parseInt(selectedCustomerId),
      loyalty_point_amount: loyaltyPoints,
      is_guest: "no",
      session_id: "request",
      is_request: "pos",
      user_id: user.user.id,
      waiter_id: selectedWaiter,
      cashier_id: selectedCashier,
      order_from: selectedOrder.order_from || "POS",
      order_type_id: selectedOrderType,
      is_coupon: "no",
      payment_method_id: selectedPaymentMethod,
      card_discount_type: cardDiscountType,
      card_discount: cardDiscountAmount,
      multiple_payments: multiplePayments,
      table_id: selectedTable,
      outlet_id: user.user.outlet_id,
      sub_total: subTotal,
      received_amount: givenAmount || 0,
      paid_amount: payAmount,
      change_amount: givenAmount - totalPayable,
      main_screen_discount_type: mainScreenDiscountType,
      main_screen_discount: mainScreenDiscount,
      order_status: "invoiced",
      approval_status: "approved",
      delivery_charges: serviceDelivery,
      items: orderItemDetail.map((order) => ({
        item_id: order.food_menu_id,
        quantity: order.food_menu_qty,
        menu_note: order.food_menu_note,
        modifiers: order.food_menu_modifier_selected?.map((modifier) => ({
          modifier_id: modifier.modifier_id,
          quantity: 1,
        })),
      })),
    };

    const addSale = async () => {
      if (selectedOrder) {
        try {
          const res = await axios.put(
            `${apiKey}/api/rms/admin/update_sale/${selectedOrder.id}`,
            order,
            {
              headers: {
                Authorization: `Bearer ${user?.token}`,
              },
            }
          );
          setInvoiceData(res.data.order_details.original);
          setTimeout(() => {
            handlePrint();
            setOrderItemDetail([]);
            setSelectedCustomerId(1);
            setSelectedOrderType(null);
            setMainScreenDiscount(0);
            setMainScreenDiscountType(null);
            setServiceDelivery(0);
            setSelectedPaymentMethod(1);
            setSelectedCashier("");
            setSelectedWaiter("");
            setSelectedTable("");
            setSelectOrder(null);
            setServiceDelivery(0);
            setDiscount(0);
            setGivenAmount(0);
            setDiscountVal(0);
            setSelectedOrder(null);
            setShowDirectInvoiceFinalizeModal(false);
          }, 100);
          fetchOrders();
          console.log(res);
        } catch (err) {
          console.log(err);
        }
      } else {
        try {
          const res = await axios.post(
            `${apiKey}/api/rms/customer/add_sale`,
            order
          );
          setInvoiceData(res.data.order_details.original);
          setTimeout(() => {
            handlePrint();
            setOrderItemDetail([]);
            setSelectedCustomerId(1);
            setSelectedOrderType(null);
            setMainScreenDiscount(0);
            setMainScreenDiscountType(null);
            setServiceDelivery(0);
            setSelectedPaymentMethod(1);
            setSelectedCashier("");
            setSelectedWaiter("");
            setSelectOrder(null);
            setSelectedOrder(null);
            setServiceDelivery(0);
            setDiscount(0);
            setGivenAmount(0);
            setDiscountVal(0);
            setShowDirectInvoiceFinalizeModal(false);
          }, 100);
          fetchOrders();
        } catch (err) {
          console.log(err);
        }
      }
    };

    // Call the function where necessary
    addSale();
  };

  const handleDirectCashInvoice = () => {
    const order = {
      customer_id: parseInt(selectedCustomerId),
      loyalty_point_amount: loyaltyPoints,
      is_guest: "no",
      session_id: "request",
      is_request: "pos",
      // is_coupon: "yes",
      // coupon_id: 1,
      user_id: user.user.id,
      waiter_id: selectedWaiter,
      cashier_id: selectedCashier,
      order_from: selectedOrder.order_from || "POS",
      order_type_id: selectedOrderType,
      is_coupon: "no",
      payment_method_id: selectedPaymentMethod,
      card_discount_type: cardDiscountType,
      card_discount: cardDiscountAmount,
      multiple_payments: multiplePayments,
      table_id: selectedTable,
      outlet_id: user.user.outlet_id,
      sub_total: subTotal,
      received_amount: givenAmount || 0,
      paid_amount: payAmount,
      change_amount: givenAmount - totalPayable,
      main_screen_discount_type: mainScreenDiscountType,
      main_screen_discount: mainScreenDiscount,
      order_status: "invoiced",
      approval_status: "approved",
      delivery_charges: serviceDelivery,
      items: orderItemDetail.map((order) => ({
        item_id: order.food_menu_id,
        quantity: order.food_menu_qty,
        menu_note: order.food_menu_note,
        modifiers: order.food_menu_modifier_selected?.map((modifier) => ({
          modifier_id: modifier.modifier_id,
          quantity: 1,
        })),
      })),
    };

    const addSale = async () => {
      if (selectedOrder) {
        try {
          const res = await axios.put(
            `${apiKey}/api/rms/admin/update_sale/${selectedOrder.id}`,
            order,
            {
              headers: {
                Authorization: `Bearer ${user?.token}`,
              },
            }
          );
          setInvoiceData(res.data.order_details.original);
          setTimeout(() => {
            handlePrint();
            setOrderItemDetail([]);
            setSelectedCustomerId(1);
            setSelectedOrderType(null);
            setMainScreenDiscount(0);
            setMainScreenDiscountType(null);
            setServiceDelivery(0);
            setSelectedPaymentMethod(1);
            setSelectedCashier("");
            setSelectedWaiter("");
            setSelectedTable("");
            setSelectOrder(null);
            setServiceDelivery(0);
            setDiscount(0);
            setGivenAmount(0);
            setDiscountVal(0);
            setSelectedOrder(null);
            setShowDirectInvoiceFinalizeModal(false);
          }, 100);
          fetchOrders();
          console.log(res);
        } catch (err) {
          console.log(err);
        }
      } else {
        try {
          const res = await axios.post(
            `${apiKey}/api/rms/customer/add_sale`,
            order
          );
          setInvoiceData(res.data.order_details.original);
          setTimeout(() => {
            handlePrint();
            setOrderItemDetail([]);
            setSelectedCustomerId(1);
            setSelectedOrderType(null);
            setMainScreenDiscount(0);
            setMainScreenDiscountType(null);
            setServiceDelivery(0);
            setSelectedPaymentMethod(1);
            setSelectedCashier("");
            setSelectedWaiter("");
            setSelectOrder(null);
            setSelectedOrder(null);
            setServiceDelivery(0);
            setDiscount(0);
            setGivenAmount(0);
            setDiscountVal(0);
            setShowDirectInvoiceFinalizeModal(false);
          }, 100);
          fetchOrders();
        } catch (err) {
          console.log(err);
        }
      }
    };

    // Call the function where necessary
    addSale();
  };

  const handleStatusUpdate = (status, id) => {
    if (selectOrder) {
      axios
        .post(
          `${apiKey}/api/rms/admin/order/${id}/order_status`,
          {
            order_status: status,
          },
          {
            headers: {
              Authorization: `Bearer ${user?.token}`,
            },
          }
        )
        .then((res) => {
          // console.log(res.data);
          fetchOrders();
          setOrderItemDetail([]);
          setSelectedCustomerId(1);
          setSelectedOrderType(null);
          setMainScreenDiscount(0);
          setMainScreenDiscountType(null);
          setServiceDelivery(0);
          setSelectedPaymentMethod(1);
          setSelectedCashier("");
          setSelectedWaiter("");
          setServiceDelivery(0);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      setAlert("Please select an order to proceed!");
    }
  };

  const fetchCustomers = useCallback(() => {
    return axios.get(`${apiKey}/api/rms/admin/customer`, {
      headers: {
        Authorization: `Bearer ${user?.token}`,
      },
    });
  }, [user?.token]);

  useEffect(() => {
    const fetchCategories = () => {
      return axios.get(`${apiKey}/api/rms/admin/categories`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          status: "active",
          outletId: user?.user.outlet_id,
        },
      });
    };

    const fetchSubCategories = () => {
      return axios.get(`${apiKey}/api/rms/admin/subCategories`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          del_status: "Live",
          outletId: user?.user.outlet_id,
        },
      });
    };

    const fetchFoodMenus = () => {
      return axios.get(`${apiKey}/api/rms/admin/foodMenus`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          catStatus: true,
          outletId: user?.user.outlet_id,
        },
      });
    };

    const fetchAllPayment = () => {
      return axios.get(`${apiKey}/api/rms/admin/get-all-payment`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: user?.user.outlet_id,
        },
      });
    };

    const fetchUsers = () => {
      return axios.get(`${apiKey}/api/rms/admin/user`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: user?.user.outlet_id,
        },
      });
    };

    const fetchTables = () => {
      return axios.get(`${apiKey}/api/rms/admin/tables`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: user?.user.outlet_id,
        },
      });
    };

    const fetchInvoiceSetting = () => {
      return axios.get(`${apiKey}/api/rms/admin/settings`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      });
    };

    const fetchLoyalty = () => {
      return axios.get(`${apiKey}/api/rms/admin/loyalty`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      });
    };

    const fetchData = () => {
      Promise.all([
        fetchCategories(),
        fetchSubCategories(),
        fetchFoodMenus(),
        fetchAllPayment(),
        fetchCustomers(),
        fetchUsers(),
        fetchTables(),
        fetchInvoiceSetting(),
        fetchLoyalty(),
      ])
        .then(
          ([
            catRes,
            subCatRes,
            foodMenuRes,
            allPaymentRes,
            customerRes,
            userRes,
            tableRes,
            settingRes,
            loyaltyRes,
          ]) => {
            setCategories(catRes.data);
            setSubCategories(subCatRes.data);
            setFoodMenus(foodMenuRes.data.foodMenus);
            setAllPaymentMethod(allPaymentRes.data);

            const mappedCustomers = customerRes.data.map((customer) => ({
              label: customer.name,
              value: customer.id,
              customer: customer,
            }));

            setCustomers(mappedCustomers);

            const walkIn = mappedCustomers.filter(
              (customer) => customer.value === 1
            )[0];

            setSelectedCustomer(walkIn?.customer);
            setSelectedCustomerId(walkIn?.value);

            const waiters = userRes.data.filter(
              (user) => user.role === "waiter"
            );

            const mappedWaiters = waiters.map((waiter) => ({
              label: waiter.name,
              value: waiter.id,
            }));

            setWaiters(mappedWaiters);

            const riders = userRes.data.filter((user) => user.role === "rider");

            const mappedRiders = riders.map((rider) => ({
              label: rider.name,
              value: rider.id,
            }));

            setRiders(mappedRiders);

            const cashiers = userRes.data.filter(
              (user) => user.role === "cashier"
            );

            const mappedCashiers = cashiers.map((cashier) => ({
              label: cashier.name,
              value: cashier.id,
            }));

            setCashiers(mappedCashiers);

            const mappedTables = tableRes.data.map((table) => ({
              label: table.name,
              value: table.id,
            }));

            setTables(mappedTables);

            setSetting(settingRes.data);

            setLoyalty(loyaltyRes.data[0]);
          }
        )
        .catch((err) => {
          if (err.response.data.status_code === 401) {
            localStorage.removeItem("rms-admin");
            navigate("/admin");
          }
        })
        .finally(() => setPageLoading(false));
    };

    handleCSRF(fetchData);

    // handleCSRF(fetchOrders);
  }, [fetchCustomers, navigate, user?.token, user?.user.outlet_id]);

  const fetchOrders = useCallback(() => {
    axios
      .get(
        `${apiKey}/api/rms/customer/fetch_all_order`,
        {
          params: {
            outletId: user?.user.outlet_id,
            orderStatus: "new",
            noDecline: true
          },
        }
      )
      .then((res) => {
        // console.log(JSON.parse(res.data.orders[0].order_items));
        setDineInOrders(
          res.data.filter(
            (item) =>
              item.approval_status === "pending" && item.order_type_id === 1
          )
        );
        setDeliveryOrders(
          res.data.filter(
            (item) =>
              item.approval_status === "pending" && item.order_type_id === 2
          )
        );
        setTakeawayOrders(
          res.data.filter(
            (item) =>
              item.approval_status === "pending" && item.order_type_id === 3
          )
        );
        setHoldORders(
          res.data.filter((item) => item.approval_status === "hold")
        );
        setOrders(
          res.data.filter((item) => item.approval_status === "approved")
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }, [user?.user.outlet_id]);

  useEffect(() => {
    handleCSRF(fetchOrders);
  }, [fetchOrders]);

  useEffect(() => {
    const interval = setInterval(() => {
      handleCSRF(fetchOrders);
    }, 10000); // 10 seconds in milliseconds

    // Cleanup function to clear the interval when the component unmounts
    return () => clearInterval(interval);
  }, [fetchOrders]);

  useEffect(() => {
    let total_discount = 0;
    let total_vat = 0;
    let sub_total = 0;

    orderItemDetail.forEach((item) => {
      sub_total +=
        parseFloat(item.food_menu_total_sale_price) *
        parseInt(item.food_menu_qty);
      total_discount += parseFloat(item.food_menu_discount);
      item.food_menu_modifier_selected?.forEach((modifier) => {
        sub_total +=
          parseFloat(modifier.modifier_price) * parseInt(item.food_menu_qty);
      });
      total_vat +=
        (item.food_menu_vat + item.food_menu_extra_vat) *
        parseInt(item.food_menu_qty);
    });

    if (selectedPaymentMethod === 7) {
      if (cardDiscountType === "amount") {
        total_discount += parseFloat(cardDiscountAmount);
      } else {
        total_discount += sub_total * (parseFloat(cardDiscountAmount) / 100);
      }
    }
    setTotalItems(orderItemDetail.length);
    setTotalDiscount((total_discount + discountVal).toFixed(2));
    setTotalVat(parseFloat(total_vat.toFixed(2)));
    setSubTotal(parseFloat(sub_total.toFixed(2)));
  }, [
    cardDiscountAmount,
    cardDiscountType,
    discountVal,
    orderItemDetail,
    selectedPaymentMethod,
  ]);

  useEffect(() => {
    // Extract the round_off setting
    const roundOff = setting.filter((set) => set.type === "invoice_settings")[0]
      ?.value
      ? JSON.parse(
          setting.filter((set) => set.type === "invoice_settings")[0].value
        ).round_off
      : "no";

    // Calculate the total payable amount
    let total = subTotal + (serviceDelivery || 0) + totalVat - totalDiscount;

    // Round off the total if roundOff is set to "yes"
    const finalTotal =
      roundOff === "yes" ? Math.round(total) : total.toFixed(2);

    setTotalPayable(finalTotal);
  }, [
    serviceDelivery,
    subTotal,
    additionalDiscount,
    totalVat,
    totalDiscount,
    setting,
  ]);

  useEffect(() => {
    setDueAmount(totalPayableFinal - payAmount);
  }, [payAmount, totalPayableFinal]);

  useEffect(() => {
    setChangeAmount(givenAmount - payAmount);
  }, [givenAmount, payAmount]);

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/verifyShift`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {})
      .catch((err) => {
        navigate("/admin/openRegister");
      });
  }, [navigate, user?.token]);

  if (pageLoading) {
    return (
      <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
        <img src="/assets/gif/dash2.gif" alt="" />
      </div>
    );
  }

  return (
    <>
      <div className="bg-[#f0f5f9] flex gap-x-4 w-full relative">
        <div
          className={`max-w-[185px] transition-all ${
            sidebarOpen ? "lg:w-full w-0" : "lg:w-0 w-0 fixed z-10"
          }`}
        >
          <button className="lg:hidden p-2 rounded-r-md z-10 bg-[#774d96] text-white fixed top-16 left-0" onClick={sidebarToggle}>
            <IoMdMenu className="text-2xl" />
          </button>
          <div
            onClick={sidebarToggle}
            className={`w-screen h-screen bg-black backdrop-blur-md bg-opacity-50 fixed top-0 left-0 z-10 lg:hidden ${
              sidebarOpen ? "hidden" : ""
            }`}
          ></div>
          <div
            className={`max-w-[185px] max-h-screen fixed top-0 left-0 bottom-0 transition-all z-10 ${
              sidebarOpen
                ? "-translate-x-full w-0 lg:translate-x-0 lg:w-full"
                : "lg:-translate-x-full lg:w-0 translate-x-0 w-full"
            } overflow-x-clip`}
          >
            <SideNavPOS
              orders={orders}
              handleSelectOrder={handleSelectOrder}
              selectOrder={selectOrder}
              handleEditOrder={handleEditOrder}
              handleOrderDetailModal={handleOrderDetailModal}
              handleOrderDetails={handleOrderDetails}
              handleStatusUpdate={handleStatusUpdate}
              fetchOrders={fetchOrders}
              handleCreateInvoice={handleCreateInvoice}
              setShowFinalizeOrderModal={setShowFinalizeOrderModal}
              setPayAmount={setPayAmount}
              setTotalPayableFinal={setTotalPayableFinal}
              setOpenKotModal={setOpenKotModal}
            />
          </div>
        </div>
        <div className="w-full flex transition-all">
          <div className="w-full px-2">
            <POSOrderDetailTable
              user={user}
              sidebarToggle={sidebarToggle}
              sidebarOpen={sidebarOpen}
              selectedOrder={selectedOrder}
              orderItemDetail={orderItemDetail}
              deliveryOrders={deliveryOrders}
              dineInOrders={dineInOrders}
              takeawayOrders={takeawayOrders}
              holdOrders={holdOrders}
              allPaymentMethod={allPaymentMethod}
              handleMultiplePaymentSubmit={handleMultiplePaymentSubmit}
              handleItemDelete={handleItemDelete}
              selectedOrderType={selectedOrderType}
              handleSelectOrderType={handleSelectOrderType}
              handleDiscountUpdate={handleDiscountUpdate}
              handleDeliveryChargeUpdate={handleDeliveryChargeUpdate}
              handleUpdateQuantity={handleUpdateQuantity}
              handleAddModifier={handleAddModifier}
              customers={customers}
              waiters={waiters}
              riders={riders}
              cashiers={cashiers}
              tables={tables}
              selectedCustomerId={selectedCustomerId}
              selectedCustomer={selectedCustomer}
              setSelectedCustomer={setSelectedCustomer}
              setAlert={setAlert}
              loyaltyPoint={loyaltyPoints}
              handleLoyalty={handleLoyalty}
              handleCustomerSelect={handleCustomerSelect}
              totalItems={totalItems}
              totalVat={totalVat}
              subTotal={subTotal}
              totalDiscount={totalDiscount}
              discount={discount}
              serviceDelivery={serviceDelivery}
              totalPayable={totalPayable}
              selectedPaymentMethod={selectedPaymentMethod}
              handleSelectedPaymentMethod={handleSelectedPaymentMethod}
              // handleDirectInvoice={setShowDirectInvoiceFinalizeModal}
              handleDirectInvoice={handleDirectInvoice}
              isUpdate={isUpdate}
              createUpdateOrder={createUpdateOrder}
              handleClearOrder={handleClearOrder}
              loyalty={loyalty}
              handleCardDiscountType={handleCardDiscountType}
              handleCardDiscountAmount={handleCardDiscountAmount}
              fetchOrders={fetchOrders}
              selectedCashier={selectedCashier}
              setSelectedCashier={setSelectedCashier}
              selectedWaiter={selectedWaiter}
              setSelectedWaiter={setSelectedWaiter}
              selectedTable={selectedTable}
              setSelectedTable={setSelectedTable}
              handleHoldOrder={handleHoldOrder}
              setSelectedOrder={setSelectedOrder}
              setSelectedOrderType={setSelectedOrderType}
              setOrderItemDetail={setOrderItemDetail}
              setIsUpdate={setIsUpdate}
              fetchCustomers={fetchCustomers}
              setCustomers={setCustomers}
              setSelectedcustomerId={setSelectedCustomerId}
            />
          </div>
          <div
            className={`w-screen h-screen bg-black backdrop-blur-md bg-opacity-50 fixed top-0 left-0 z-10 lg:hidden ${
              !menuOpen && "hidden"
            }`}
            onClick={() => setMenuOpen(false)}
          ></div>
          <div
            className={`lg:w-full w-[75%] bg-white px-2 fixed lg:static top-0 right-0 lg:transalte-x-0 ${
              !menuOpen
                ? "translate-x-full lg:translate-x-0 min-h-screen"
                : "translate-x-0"
            } z-50 lg:z-0 transition-all`}
          >
            <button
              className="lg:hidden absolute top-10 left-0 -translate-x-full bg-[#774d96] text-white text-lg font-medium px-4 py-1 rounded-tl rounded-bl"
              onClick={() => setMenuOpen(!menuOpen)}
            >
              {menuOpen ? "Close" : "Menu"}
            </button>
            <POSRightHeader />
            <POSCategory
              categories={categories}
              subCategories={subCategories}
              foodMenus={foodMenus}
              handleItemSelect={handleItemSelect}
              handleIsSubCat={handleIsSubCat}
              isSubCat={isSubCat}
            />
          </div>
        </div>
      </div>
      {showOrderDetailModal && (
        <POSOrderDetail
          toggle={handleOrderDetailModal}
          orderDetails={orderDetails}
          handleCreateInvoice={handleCreateInvoice}
          setShowFinalizeOrderModal={setShowFinalizeOrderModal}
          setPayAmount={setPayAmount}
          setTotalPayableFinal={setTotalPayableFinal}
        />
      )}
      {showFinalizeOrderModal && (
        <div
          className="fixed z-10 top-0 left-0 w-full bg-black bg-opacity-50 min-h-screen grid place-items-center"
          onClick={() => {
            setPayAmount(0);
            setDueAmount(0);
            setTotalPayableFinal(0);
            setGivenAmount(0);
            setChangeAmount(0);
            setShowFinalizeOrderModal(false);
          }}
        >
          <div
            className="max-w-lg w-full bg-white rounded-lg overflow-hidden relative"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="bg-[#774d96] text-white flex justify-between items-center px-4 py-3">
              <h2 className="text-lg font-semibold">Finalize Order</h2>
              <RxCross1
                className="cursor-pointer hover:text-gray-200"
                onClick={() => {
                  setPayAmount(0);
                  setDueAmount(0);
                  setTotalPayableFinal(0);
                  setGivenAmount(0);
                  setChangeAmount(0);
                  setShowFinalizeOrderModal(false);
                }}
              />
            </div>
            <div className="p-4 space-y-4">
              <div className="flex justify-between items-center border-b pb-2">
                <span className="font-medium">Total Payable</span>
                <span className="font-semibold text-gray-800">
                  SR {totalPayableFinal}
                </span>
              </div>
              <div className="flex items-center gap-4">
                <label className="w-full">Payment Method</label>
                <select
                  className="border border-gray-300 rounded p-2 w-full"
                  onChange={(e) => setSelectedPaymentMethod(e.target.value)}
                >
                  <option value="">Select Method</option>
                  <option value="1" selected>
                    Cash
                  </option>
                  <option value="2">Mada</option>
                  <option value="3">Visa</option>
                  <option value="4">Master Card</option>
                </select>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block mb-1">Pay Amount</label>
                  <input
                    type="text"
                    className="border border-gray-300 rounded p-2 w-full"
                    onChange={(e) =>
                      setPayAmount(parseFloat(e.target.value) || 0)
                    }
                    value={payAmount}
                  />
                </div>
                <div>
                  <label className="block mb-1">Due Amount</label>
                  <input
                    type="text"
                    className="border border-gray-300 rounded p-2 w-full"
                    onChange={(e) => setDueAmount(parseFloat(e.target.value))}
                    value={dueAmount}
                  />
                </div>
                <div>
                  <label className="block mb-1">Given Amount</label>
                  <input
                    type="text"
                    className="border border-gray-300 rounded p-2 w-full"
                    onChange={(e) => setGivenAmount(e.target.value || 0)}
                    value={givenAmount}
                  />
                </div>
                <div>
                  <label className="block mb-1">Change Amount</label>
                  <input
                    type="text"
                    className="border border-gray-300 rounded p-2 w-full"
                    onChange={(e) => setChangeAmount(e.target.value)}
                    value={changeAmount}
                  />
                </div>
              </div>
              <div className="flex justify-end gap-4 mt-4">
                <button
                  onClick={() => {
                    setPayAmount(0);
                    setDueAmount(0);
                    setTotalPayableFinal(0);
                    setGivenAmount(0);
                    setChangeAmount(0);
                    setShowFinalizeOrderModal(false);
                  }}
                  className="text-white bg-[#774d96] px-4 py-2 rounded-md"
                >
                  Cancel
                </button>
                <button
                  onClick={() => handleCreateInvoice()}
                  className="text-white bg-[#774d96] px-4 py-2 rounded-md"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showDirectInvoiceFinalizeModal && (
        <div
          className="fixed z-10 top-0 left-0 w-full bg-black bg-opacity-50 min-h-screen py-16"
          onClick={() => setShowDirectInvoiceFinalizeModal(false)}
        >
          <div
            className="max-w-lg w-full bg-white rounded-lg overflow-hidden relative mx-auto p-4"
            onClick={(e) => e.stopPropagation()}
          >
            <h1 className="text-2xl font-semibold text-center">
              Received Amount
            </h1>
            <div>
              <div>
                <label className="block mb-1">Given Amount</label>
                <input
                  type="text"
                  className="border border-gray-300 rounded p-2 w-full"
                  onChange={(e) =>
                    setGivenAmount(parseFloat(e.target.value) || 0)
                  }
                  value={givenAmount}
                />
              </div>
              {givenAmount < totalPayable && (
                <p className="text-red-500 text-sm">
                  Received amount cannot be less than the total amount.
                </p>
              )}
              <div>
                <label className="block mb-1">Change Amount</label>
                <input
                  type="text"
                  className="border border-gray-300 bg-gray-200 cursor-not-allowed rounded p-2 w-full"
                  disabled
                  onChange={(e) => setChangeAmount(parseFloat(e.target.value))}
                  value={givenAmount - totalPayable}
                />
              </div>
              <div className="flex justify-end gap-4 mt-4">
                <button
                  className="text-white bg-[#774d96] px-4 py-2 rounded-md"
                  onClick={() => setShowDirectInvoiceFinalizeModal(false)}
                >
                  Cancel
                </button>
                <button
                  className="text-white bg-[#774d96] px-4 py-2 rounded-md"
                  onClick={() => {
                    if (givenAmount < totalPayable) return;
                    handleDirectCashInvoice();
                  }}
                >
                  Direct Invoice
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {alert && (
        <AlertModal alert={alert} handleCloseAlert={handleCloseAlert} />
      )}
      {openKotModal && (
        <KotModal
          orderDetails={orderDetails}
          setOpenKotModal={setOpenKotModal}
        />
      )}
      {invoiceData && (
        <div className="hidden">
          <div ref={componentRef}>
            <InvoiceMain setting={setting} invoiceDetails={invoiceData} />
          </div>
        </div>
      )}
    </>
  );
}

export default POSMain;

function KotModal({ orderDetails, setOpenKotModal }) {
  const [selectedOrders, setSelectedOrders] = useState([]);
  const componentRef = useRef(null);

  // Initialize selectedOrders with all items and their modifiers
  useEffect(() => {
    if (orderDetails?.order_details) {
      setSelectedOrders(
        orderDetails.order_details.map((order) => ({
          ...order,
          selected_modifiers: order.modifiers ? [...order.modifiers] : [], // Ensure modifiers are initialized
        }))
      );
    }
  }, [orderDetails]);

  // Toggle individual item selection
  const handleSelectItem = (order) => {
    setSelectedOrders((prevSelected) => {
      const isAlreadySelected = prevSelected.some(
        (selectedOrder) => selectedOrder.food_menu_id === order.food_menu_id
      );
      if (isAlreadySelected) {
        return prevSelected.filter(
          (selectedOrder) => selectedOrder.food_menu_id !== order.food_menu_id
        );
      } else {
        return [
          ...prevSelected,
          {
            ...order,
            selected_modifiers: order.modifiers ? [...order.modifiers] : [],
          },
        ];
      }
    });
  };

  // Toggle "Select All" checkbox
  const handleSelectAll = () => {
    if (selectedOrders.length === orderDetails.order_details.length) {
      setSelectedOrders([]);
    } else {
      setSelectedOrders(
        orderDetails.order_details.map((order) => ({
          ...order,
          selected_modifiers: order.modifiers ? [...order.modifiers] : [],
        }))
      );
    }
  };

  // Update quantity of a specific item in selectedOrders
  const updateOrderQuantity = (id, newQty) => {
    setSelectedOrders((prevSelected) =>
      prevSelected.map((order) =>
        order.food_menu_id === id ? { ...order, qty: newQty } : order
      )
    );
  };

  // Toggle modifier selection for an item
  const handleToggleModifier = (orderId, modifier) => {
    setSelectedOrders((prevSelected) =>
      prevSelected.map((order) => {
        if (order.food_menu_id === orderId) {
          const isModifierSelected = order.selected_modifiers?.some(
            (mod) => mod.name === modifier.name
          );
          const updatedModifiers = isModifierSelected
            ? order.selected_modifiers.filter(
                (mod) => mod.name !== modifier.name
              )
            : [...(order.selected_modifiers || []), modifier];
          return { ...order, selected_modifiers: updatedModifiers };
        }
        return order;
      })
    );
  };

  // Check if all items are selected
  const isAllSelected =
    selectedOrders.length === orderDetails.order_details.length;

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "Invoice",
  });

  return (
    <div
      className="h-screen w-full z-20 fixed top-0 left-0 bg-black bg-opacity-50 backdrop-blur-md grid place-items-center"
      onClick={() => setOpenKotModal(false)}
    >
      <div
        className="bg-white rounded-md max-w-xl w-full py-2"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="text-center py-2">
          <h1 className="text-2xl font-bold">KOT</h1>
          <p>Order No: {orderDetails.sale_no}</p>
          <p>Date: {orderDetails.date_time}</p>
          <p>
            Customer:{" "}
            {orderDetails.is_guest === "no"
              ? orderDetails.customer?.name
              : orderDetails.guest?.name}
          </p>
          <p>Table: {orderDetails.table?.name || "None"}</p>
          <p>Waiter: None, Order Type: {orderDetails.order_type.type}</p>
        </div>
        <table className="w-full">
          <thead className="bg-[#774d96] text-white text-lg">
            <tr>
              <th className="text-start px-2">
                <input
                  type="checkbox"
                  checked={isAllSelected}
                  onChange={handleSelectAll}
                />
              </th>
              <th className="text-start px-2">Item</th>
              <th className="text-start px-2">Qty</th>
              <th className="text-start px-2">Add Ons</th>
            </tr>
          </thead>
          <tbody>
            {orderDetails.order_details.map((order, index) => (
              <tr key={index}>
                <td className="px-2">
                  <input
                    type="checkbox"
                    checked={selectedOrders.some(
                      (selectedOrder) =>
                        selectedOrder.food_menu_id === order.food_menu_id
                    )}
                    onChange={() => handleSelectItem(order)}
                  />
                </td>
                <td className="px-2">{order.name}</td>
                <td className="px-2">
                  <QuantityInput
                    item={order}
                    updateQuantity={updateOrderQuantity}
                  />
                </td>
                <td className="px-2">
                  <div className="flex flex-wrap gap-2">
                    {order.modifiers?.map((mod, index) => (
                      <span
                        key={index}
                        className={`border rounded text-sm px-2 py-1 cursor-pointer ${
                          selectedOrders
                            .find(
                              (selectedOrder) =>
                                selectedOrder.food_menu_id ===
                                order.food_menu_id
                            )
                            ?.selected_modifiers?.some(
                              (selectedMod) => selectedMod.name === mod.name
                            )
                            ? "bg-[#774d96] bg-opacity-50"
                            : ""
                        }`}
                        onClick={() =>
                          handleToggleModifier(order.food_menu_id, mod)
                        }
                      >
                        {mod.name}
                      </span>
                    ))}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="flex gap-4 justify-between px-4 mt-16">
          <button
            className="bg-[#774d96] text-white text-lg font-medium text-center px-4 py-1 rounded"
            onClick={() => setOpenKotModal(false)}
          >
            Cancel
          </button>
          <button
            className="bg-[#774d96] text-white text-lg font-medium text-center px-4 py-1 rounded"
            onClick={() => {
              handlePrint();
              setOpenKotModal(false);
            }}
          >
            Print KOT
          </button>
        </div>
      </div>
      <div className="hidden">
        <div ref={componentRef}>
          <KOTSingle orders={selectedOrders} data={orderDetails} />
        </div>
      </div>
    </div>
  );
}

function QuantityInput({ item, updateQuantity }) {
  // Initialize the state with the item's original quantity
  const [quantity, setQuantity] = useState(item.qty);
  // Function to increment quantity
  const incrementQty = () => {
    const newQty = quantity + 1;
    setQuantity(newQty);
    updateQuantity(item.food_menu_id, newQty);
  };

  // Function to decrement quantity
  const decrementQty = () => {
    // Ensure quantity does not go below the initial item quantity
    const newQty = quantity > item.qty ? quantity - 1 : item.qty;
    setQuantity(newQty);
    updateQuantity(item.food_menu_id, newQty);
  };

  // Handle manual input change
  const handleInputChange = (e) => {
    const newQty = parseInt(e.target.value || 0);
    // Ensure the quantity is not less than the initial item quantity
    const validQty = newQty >= item.qty ? newQty : item.qty;
    setQuantity(validQty);
    updateQuantity(item.food_menu_id, validQty);
  };

  return (
    <span className="flex gap-x-1">
      {/* Decrement Button */}
      <button className="bg-[#774b96] p-1 rounded" onClick={decrementQty}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="16"
          width="14"
          viewBox="0 0 448 512"
          fill="white"
        >
          <path d="M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z" />
        </svg>
      </button>

      {/* Quantity Input */}
      <input
        className="w-8 border rounded text-center"
        type="text"
        value={quantity}
        onChange={handleInputChange}
      />

      {/* Increment Button */}
      <button className="bg-[#774b96] p-1 rounded" onClick={incrementQty}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="16"
          width="14"
          viewBox="0 0 448 512"
          fill="white"
        >
          <path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z" />
        </svg>
      </button>
    </span>
  );
}

function AlertModal({ alert, handleCloseAlert }) {
  return (
    <div className="h-screen w-full z-20 fixed top-0 left-0 bg-black bg-opacity-50 backdrop-blur-md grid place-items-center">
      <div className="bg-white rounded-lg max-w-md w-full overflow-hidden p-4">
        <h2 className="text-[#595959] text-3xl font-bold text-center">
          Alert!
        </h2>
        <p className="text-[#595959] my-4 text-center">{alert}</p>
        <div className="w-full my-2">
          <button
            onClick={() => handleCloseAlert()}
            className="bg-[#774d96] px-5 py-1 text-white text-lg font-bold rounded mx-auto block"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
}
